module.exports = __webpack_public_path__ + "img/ic-flag-black.4203a57c.svg";